/**
 * Removes all match indices in a link.
 *
 * @param {Link} link
 */
export function removeMatches(link) {
    link.match = [];
    return link;
}
//# sourceMappingURL=removeMatches.js.map